

import React, { useEffect, useState, forwardRef, useRef } from "react";
// import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Dialog, DialogTitle, TextField, DialogActions, Container, Popover,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, DialogContent, Snackbar, RadioGroup, FormControlLabel, Radio, Checkbox, Divider, Chip, Grid, Card, CardContent, Alert, AlertTitle
} from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';
// import { downloadExcel } from 'react-export-table-to-excel';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell, StyledTableCellPrint } from '../../reusableComponent/StyledTable'
import { useDispatch, useSelector } from "react-redux";
import { UploadAttachmentFooter, UploadAttachmentSignature, UploadAttachmentWatermark, addPrintSetup, editPrintSetup, getPrintSetupList, } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { dateConversionOnEntryPage, dateConversionOnEntryPageWithTime } from "../../reusableComponent/dateConversionOnEntryPage";
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import { ERPinput, ERPinputNo } from "../../reusableComponent/ErpTextField";
import watermark from '../../../images/transfrent_logo2.png'
import { financialYear } from "../../reusableComponent/financialYear";
import { useForm } from "react-hook-form";
import { BackBtn } from "../../reusableComponent/BackBtn";

function PrintSetup(props) {
    const dispatch = useDispatch();
    const [successMessage, setSuccessMessage] = useState(null);
    const { handleSubmit } = useForm();
    let ref = useRef();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [openPopup, setOpenPopup] = React.useState(false);
    const rows = useSelector(state => state.printSetup.printSetup)

    const [topMargin, setTopMargin] = React.useState('100');
    const [watermarkRequired, setWatermarkRequired] = React.useState('Watermark Text');
    const [watermarkImgCheckbox, setWatermarkImgCheckbox] = useState(true);
    const [watermarkTextCheckbox, setWatermarkTextCheckbox] = useState(true);
    const [watermarkText, setWatermarkText] = useState('');
    const [watermarkTextRotate, setWatermarkTextRotate] = useState(0);
    const [footerImgCheckbox, setFooterImgCheckbox] = useState(false);
    const [signatureImgCheckbox, setSignatureImgCheckbox] = useState(true);
    const watermarkImage = useSelector(state => state.printSetup.watermarkAttachment)
    const footerImage = useSelector(state => state.printSetup.footerAttachment)
    const signatureImage = useSelector(state => state.printSetup.signatureAttachment)
    const [footerI, setFooterI] = useState('') 
    const [watermarkI, setWatermarkI] = useState('');
    const [signatureI, setSignatureI] = useState('')
    const [invoiceTag1, setInvoiceTag1] = useState('');
    const [invoiceTag2, setInvoiceTag2] = useState('');
    const [invoiceTag3, setInvoiceTag3] = useState('');

    const fetchData = () => {
        dispatch(getPrintSetupList({ companyId: userInfo.companyId }))
    };
    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
        console.log(rows)
        if (rows.length > 0) {
            setWatermarkRequired(rows[0].watermarkImgCheckbox === 'true' ? 'Watermark Image' : rows[0].watermarkTextCheckbox === 'true' ? 'Watermark Text' : 'No')
            setTopMargin(rows[0].topMargin)
            setWatermarkText(rows[0].watermarkText)
            setWatermarkTextRotate(rows[0].watermarkTextRotate)
            setWatermarkImgCheckbox(rows[0].watermarkImgCheckbox === 'true' ? true : false)
            setWatermarkTextCheckbox(rows[0].watermarkTextCheckbox === 'true' ? true : false)
            setFooterImgCheckbox(rows[0].footerImgCheckbox === 'true' ? true : false)
            setSignatureImgCheckbox(rows[0].signatureImgCheckbox === 'true' ? true : false)
            setFooterI(rows[0].footerImage)
            setWatermarkI(rows[0].watermarkImage)
            setSignatureI(rows[0].signatureImage)
            setInvoiceTag1(rows[0].invoiceTag1)
            setInvoiceTag2(rows[0].invoiceTag2)
            setInvoiceTag3(rows[0].invoiceTag3)
        }

    }, [rows]);


    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.printSetup.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);

    const handleChange = (event) => {
        setTopMargin(event.target.value);
    };
    const handleChange1 = (event) => {
        setWatermarkRequired(event.target.value);
    };
    const handleChangewatermarkText = (event) => {
        setWatermarkText(event.target.value);
    };
    const handleChangeInvoiceTag1 = (event) => {
        setInvoiceTag1(event.target.value);
    };
    const handleChangeInvoiceTag2 = (event) => {
        setInvoiceTag2(event.target.value);
    };
    const handleChangeInvoiceTag3 = (event) => {
        setInvoiceTag3(event.target.value);
    };
    const handleChangewatermarkTextRotate = (event) => {
        setWatermarkTextRotate(event.target.value);
    };
    const handleChangeWatermarkCheckbox = (event) => {
        setWatermarkImgCheckbox(event.target.checked);
    };
    const handleChangeWatermarkTextCheckbox = (event) => {
        setWatermarkTextCheckbox(event.target.checked);
    };

    const handleChangeFooterImgCheckbox = (event) => {
        setFooterImgCheckbox(event.target.checked);
    };
    const handleChangeSignatureImgCheckbox = (event) => {
        setSignatureImgCheckbox(event.target.checked);
    };

    const uploadFileWatermark = async (event) => {
        try {
            const selectedFile = event.target.files[0];
            const formData = new FormData();
            formData.append('file', selectedFile);
            await dispatch(UploadAttachmentWatermark(formData));
        } catch (error) {
            console.error('Error uploading file:', error); // Log the error for debugging
        }
       
    };

    const uploadFileFooter = async (event) => {
        try {
            const selectedFile = event.target.files[0];
            const formData = new FormData();
            formData.append('file', selectedFile);
            await dispatch(UploadAttachmentFooter(formData));
        } catch (error) {
            console.error('Error uploading file:', error); // Log the error for debugging
        }
        
    };
    const uploadFileSignature = async (event) => {
        try {
            const selectedFile = event.target.files[0];
            const formData = new FormData();
            formData.append('file', selectedFile);
            await dispatch(UploadAttachmentSignature(formData));
        } catch (error) {
            console.error('Error uploading file:', error); // Log the error for debugging
        }
        
    };
    const onSubmit = (event) => {
        const sending_data = {
            companyId: userInfo.companyId,
            id: rows.length > 0 ? rows[0].id : null,
            topMargin: topMargin,
            watermarkText: watermarkText,
            watermarkTextRotate: watermarkTextRotate,
            watermarkImgCheckbox: watermarkRequired === 'No' ? 'false' : watermarkRequired === 'Watermark Image' ? 'true' : 'false',
            watermarkTextCheckbox: watermarkRequired === 'No' ? 'false' : watermarkRequired === 'Watermark Text' ? 'true' : 'false',
            footerImgCheckbox: footerImgCheckbox,
            signatureImgCheckbox: signatureImgCheckbox,
            invoiceTag1: invoiceTag1,
            invoiceTag2: invoiceTag2,
            invoiceTag3: invoiceTag3,
            watermarkImage: watermarkImage == '' ? rows.length > 0 ? rows[0].watermarkImage : watermarkImage : watermarkImage,
            footerImage: footerImage == '' ? rows.length > 0 ? rows[0].footerImage : footerImage : footerImage,
            signatureImage: signatureImage == '' ? rows.length > 0 ? rows[0].signatureImage : signatureImage : signatureImage,
            createdBy: rows.length > 0 ? rows[0].createdBy : userInfo.userId,
            createdAt: rows.length > 0 ? rows[0].createdAt : dateConversionOnEntryPageWithTime(new Date()),
            modifiedBy: rows.length > 0 ? userInfo.userId : null,
            modifiedAt: rows.length > 0 ? dateConversionOnEntryPageWithTime(new Date()) : '',
        }
        if (rows.length > 0) {
            dispatch(editPrintSetup(sending_data));
        } else {
            dispatch(addPrintSetup(sending_data));
        }
    }

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Settings', path: '/settings' },
                    { name: 'Create Print Setup' },
                ]}
            />
            <Paper className={`${styles.list_container}`}>

                {/* <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={12} xs={12}>
                            <Typography className={`${styles.page_title}`}>Print Setup</Typography>
                        </Grid>
                    </Grid>
                </Box> */}
                <Box sx={{ m: 2 }} > </Box>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 0.5, pb: 0.5 }}>

                        <Grid item md={6} xs={12}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={1} sx={{ mt: 0 }}>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Print in Letter Head / Top Margin</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <RadioGroup
                                            // row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="topMargin"
                                                value="100"
                                                onChange={handleChange}
                                                checked={topMargin === '100'}
                                                label={<span style={{ fontSize: '12px' }}>Standard Print Format</span>}
                                            />

                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="topMargin"
                                                value="150"
                                                onChange={handleChange}
                                                checked={topMargin === '150'}
                                                label={<span style={{ fontSize: '12px' }}> 39.68 MM (150px )</span>}
                                            />
                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="topMargin"
                                                value="190"
                                                onChange={handleChange}
                                                checked={topMargin === '190'}
                                                label={<span style={{ fontSize: '12px' }}> 50.27 MM (190px )</span>}
                                            />
                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="topMargin"
                                                value="225"
                                                onChange={handleChange}
                                                checked={topMargin === '225'}
                                                label={<span style={{ fontSize: '12px' }}>59.53 MM (225px )</span>}
                                            />
                                        </RadioGroup>
                                    </Grid>
                        {/* ===================================================================================================== */}
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Watermark Required ? </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="watermarkRequired"
                                                value="No"
                                                onChange={handleChange1}
                                                checked={watermarkRequired === 'No'}
                                                label={<span style={{ fontSize: '12px' }}>No</span>}
                                            />
                                        <RadioGroup
                                            // row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="watermarkRequired"
                                                value="Watermark Text"
                                                onChange={handleChange1}
                                                checked={watermarkRequired === 'Watermark Text'}
                                                label={<span style={{ fontSize: '12px' }}>Watermark Text</span>}
                                            />

                                            <FormControlLabel
                                                control={<Radio size="small" sx={{ padding: '0px 12px' }} />}
                                                name="watermarkRequired"
                                                value="Watermark Image"
                                                onChange={handleChange1}
                                                checked={watermarkRequired === 'Watermark Image'}
                                                label={<span style={{ fontSize: '12px' }}>Watermark Image</span>}
                                            />
                                          
                                        </RadioGroup>
                                       
                                    </Grid>

                        {/* ===================================================================================================== */}
                           
                                    <Grid item xs={12} >
                                        <>
                                        {watermarkRequired === 'Watermark Image'  &&
                                        
                                            <> 
                                           
                                                        <Grid container spacing={1} sx={{}}>
                                                            <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                                                <Typography className={`${styles.erp_lable}`}>Upload Watermark Image</Typography>
                                                            </Grid>
                                                            <Grid item xs={8} >
                                                            <Alert severity="info">
                                                             <AlertTitle>Info</AlertTitle>
                                                              <Typography sx={{fontSize:'10px'}}>For Better Result Image was resized to fit within the maximum dimensions 
                                                               <strong> 200 x 140 pixels </strong> and Image will be transparent  </Typography></Alert>
                                                                <div style={{ display: 'flex' }}>
                                                                    <ERPinput
                                                                        variant="standard"
                                                                        InputProps={{
                                                                            disableUnderline: true,
                                                                        }}
                                                                        accept="image/*" name="logo_image" id="contained-button-file" type="file"
                                                                        onChange={uploadFileWatermark} style={{ width: '80%', }} />

                                                                    <img src={watermarkI} alt="Not Available" height={30} width={80} style={{fontSize: '10px'}}/>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                            </>
                                        }  
                                        {watermarkRequired === 'Watermark Text'  &&
                                            <>
                                                        <Grid container spacing={1} sx={{}}>
                                                            <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                                                <Typography className={`${styles.erp_lable}`}>Watermark Text</Typography>
                                                            </Grid>
                                                            <Grid item xs={6} >
                                                                <ERPinput
                                                                 size='small'
                                                                 fullWidth
                                                                  name="watermarkText"
                                                                  type="text"
                                                                  onChange={handleChangewatermarkText}
                                                                  value={watermarkText}
                                                                />
                                                            </Grid>
                                                            </Grid>
                                                            <Grid container spacing={1} sx={{mt: 0.5}}>
                                                            <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                                                <Typography className={`${styles.erp_lable}`}>Rotate (deg)</Typography>
                                                            </Grid>
                                                            <Grid item xs={6} >
                                                            <ERPinputNo
                                                                 size='small'
                                                                 fullWidth
                                                                 name="watermarkTextRotate"
                                                                 type="number"
                                                                 onChange={handleChangewatermarkTextRotate}
                                                                 value={watermarkTextRotate}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                   </>
                                          }
                                        </>
                                        
                                    </Grid>
                                   
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Image In Footer Required ? </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Checkbox
                                                sx={{ transform: 'scale(0.95)', height: '2px', padding: '9px 4px 5px 1px' }}
                                                size="small"
                                                name="footerImgCheckbox"
                                                checked={footerImgCheckbox}
                                                value={footerImgCheckbox}
                                                onChange={(event) => handleChangeFooterImgCheckbox(event)}
                                            />
                                        </Grid>
                                  

                                    {footerImgCheckbox == true &&
                                        <>
                                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Upload Image In Footer</Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <div style={{ display: 'flex' }}>
                                                    <ERPinput
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        accept="image/*" name="logo_image" id="contained-button-file" type="file"
                                                        onChange={uploadFileFooter} style={{ width: '80%', }} />

                                                        <img src={footerI} alt="Not Available" height={30} width={80} style={{fontSize: '10px'}}/>
                                                </div>
                                            </Grid>
                                        </>
                                    }

                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Digital Signature / Stamp Required ? </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Checkbox
                                            sx={{ transform: 'scale(0.95)', height: '2px', padding: '9px 4px 5px 1px' }}
                                            size="small"
                                            name="signatureImgCheckbox"
                                            checked={signatureImgCheckbox}
                                            value={signatureImgCheckbox}
                                            onChange={(event) => handleChangeSignatureImgCheckbox(event)}
                                        />
                                    </Grid>

                                    {signatureImgCheckbox == true &&
                                        <>
                                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                                <Typography className={`${styles.erp_lable}`}>Upload Image Signature / Stamp</Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <div style={{ display: 'flex' }}>
                                                    <ERPinput
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        accept="image/*" name="signatureImage" id="contained-button-file" type="file"
                                                        onChange={uploadFileSignature} style={{ width: '80%', }} />

                                                        <img src={signatureI} alt="Not Available" height={30} width={80} style={{fontSize: '10px'}}/>
                                                </div>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                                <Grid container spacing={1} sx={{mt: 0.5}}>
                                        <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                           <Typography className={`${styles.erp_lable}`}>Invoice Tag1</Typography>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                name="invoiceTag1"
                                                type="text"
                                                onChange={handleChangeInvoiceTag1}
                                                value={invoiceTag1}
                                            />
                                       </Grid>
                                </Grid>
                                <Grid container spacing={1} sx={{mt: 0.5}}>
                                        <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                           <Typography className={`${styles.erp_lable}`}>Invoice Tag2</Typography>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                name="invoiceTag2"
                                                type="text"
                                                onChange={handleChangeInvoiceTag2}
                                                value={invoiceTag2}
                                            />
                                       </Grid>
                                </Grid>
                                <Grid container spacing={1} sx={{mt: 0.5}}>
                                        <Grid item xs={4}  className={`${styles.grid_lable}`}>
                                           <Typography className={`${styles.erp_lable}`}>Invoice Tag1</Typography>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                name="invoiceTag3"
                                                type="text"
                                                onChange={handleChangeInvoiceTag3}
                                                value={invoiceTag3}
                                            />
                                       </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{ marginTop: '15px', }}>
                                        <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            {rows.length > 0 ? 'Update' : 'Save'}
                                        </Button>
                                    </Box>
                                </Grid>
                            </form>
                        </Grid>

                        <Grid item md={6} xs={12}>
                            <Box >
                                <Typography sx={{ fontSize: '22px', fontWeight: 'bold', }}> Print Preview</Typography>
                                <Paper sx={{
                                    // backgroundImage: watermarkImgCheckbox ? `url(${watermark})` : 'none',
                                    // backgroundRepeat: 'no-repeat',
                                    // backgroundPosition: 'center',
                                    position: 'relative',
                                    margin: '5px 15px 30px 15px', boxShadow: 'none', border: '1px solid #000000', height: '100vh', width: '80vh'
                                }}   >
                                    <div
                                        style={{
                                            content: '"',
                                            backgroundImage: watermarkImgCheckbox ? `url(${rows.length > 0 ? rows[0].watermarkImage : watermarkImage})` : 'none',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center',
                                            width: '90%',
                                            height: '90%',
                                            position: 'absolute', // Position absolutely
                                            // transform: 'rotate(-40deg)',
                                            opacity: 0.5,// Rotate only the background image by 30 degrees
                                        }}
                                    ></div>
                                    <Grid container sx={{}}>

                                        {topMargin == "150" &&
                                            <Box sx={{ height: '80px', width: '100%', backgroundColor: '#cfe1f7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Divider orientation="vertical" flexItem sx={{ margin: '0 4px', fontWeight: 'bold' }}>
                                                    <Typography variant="caption" style={{ transform: 'rotate(-90deg)' }}>39.68 MM <span style={{ fontSize: '8px' }}>(150 px)</span></Typography>
                                                </Divider>
                                            </Box>
                                        }
                                        {topMargin == "190" &&
                                            <Box sx={{ height: '100px', width: '100%', backgroundColor: '#cfe1f7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Divider orientation="vertical" flexItem sx={{ margin: '0 4px', fontWeight: 'bold' }}>
                                                    <Typography variant="caption" style={{ transform: 'rotate(-90deg)' }}>50.27 MM <span style={{ fontSize: '8px' }}>(190 px)</span></Typography>
                                                </Divider>
                                            </Box>

                                        }
                                        {topMargin == "225" &&
                                            <Box sx={{ height: '120px', width: '100%', backgroundColor: '#cfe1f7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Divider orientation="vertical" flexItem sx={{ margin: '0 4px', fontWeight: 'bold' }}>
                                                    <Typography variant="caption" style={{ transform: 'rotate(-90deg)' }}>59.53 MM <span style={{ fontSize: '8px' }}>(225px )</span></Typography>
                                                </Divider>
                                            </Box>
                                        }
                                        <Grid item xs={12} sx={{ backgroundColor: '#c0c0c0' }}>
                                            <Typography sx={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', padding: '1px' }}>
                                                PURCHASE ORDER
                                            </Typography>
                                        </Grid>
                                        {topMargin == "100" &&
                                            <>
                                                <Grid item xs={12} sx={{ borderTop: '1px solid #616161' }}>
                                                    <Box >
                                                        <Grid container >
                                                            <Grid item md={2} sx={{ padding: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid #616161' }}>
                                                                <img src={userInfo.logo_image} style={{ width: '60px', height: '60px', borderRadius: '4px' }} />
                                                            </Grid>
                                                            <Grid item md={10} sx={{ padding: '4px 4px 4px 10px', }}>
                                                                <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}> {userInfo.company}
                                                                </Typography>
                                                                <Grid container sx={{}}>
                                                                    <Grid item xs={0.6} >
                                                                        <Typography className={`${styles.text_Print_setup}`}>
                                                                            <Icon icon="fa-regular:address-card" />
                                                                        </Typography>
                                                                        <Typography className={`${styles.text_Print_setup}`}>
                                                                            <Icon icon="fa-regular:address-card" color="#ffffff" />
                                                                        </Typography>
                                                                        <Typography className={`${styles.text_Print_setup}`}>
                                                                            <Icon icon="bi:telephone" />
                                                                        </Typography>
                                                                        <Typography className={`${styles.text_Print_setup}`}>
                                                                            <Icon icon="mdi-light:email" height="14px" />
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={11.4}>
                                                                        <Box>
                                                                            <Typography className={`${styles.text_Print_setup}`}>
                                                                                {userInfo.companyAddress}
                                                                            </Typography>
                                                                            <Typography className={`${styles.text_Print_setup}`}>
                                                                                {userInfo.state} , {userInfo.companyPinCode}
                                                                            </Typography>
                                                                            <Typography className={`${styles.text_Print_setup}`} >
                                                                                {userInfo.mobileNumber}
                                                                            </Typography>
                                                                            <Typography className={`${styles.text_Print_setup}`} >
                                                                                {userInfo.email}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                            </>
                                        }
                                        {/* </Box>
                                        } */}


                                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', height: '14px' }}>
                                            <Grid container >
                                                <Grid item xs={6} >
                                                    <Grid container sx={{ padding: '1px 1px 1px 8px', }}>
                                                        <Grid item xs={3} >
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '8px' }}>
                                                                GSTIN
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={0.5}  >
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '8px' }}>:</Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={8.5} >
                                                            <Box>
                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}> {userInfo.companyGstIN}</Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} sx={{ borderLeft: '1px solid #616161' }}>
                                                    <Grid container sx={{ padding: '1px 1px 1px 8px', }}>
                                                        <Grid item xs={3} >
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '8px' }}>
                                                                PAN No
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={0.5}  >
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '8px' }}>:</Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={8.5} >
                                                            <Box>
                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}> {userInfo.companyPanNo}</Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ marginRight: '4px', borderTop: '1px solid #616161', borderBottom: '1px solid #616161', }}>
                                        <Grid item xs={6} sx={{ borderRight: '1px solid #616161', }}>
                                            <Box sx={{ paddingLeft: '6px', margin: '6px', textAlign: 'left', backgroundColor: '#ffffff' }}>
                                                <Typography sx={{ fontSize: '8px', fontWeight: 'bold' }}>
                                                    Bill To:
                                                </Typography>
                                                <Typography sx={{ fontSize: '9px', fontWeight: 'bold' }}>
                                                    XYZ XYZ PVT. LTD
                                                </Typography>
                                                <Typography className={`${styles.text_Print_setup}`}>
                                                    XYZ AREA, ABC COMPLEX, ABC ROAD, DIST-XYZ ,PIN-000000
                                                </Typography>
                                                <Typography className={`${styles.text_Print_setup}`}>
                                                    GSTIN: **************
                                                </Typography>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={6} sx={{}}>
                                            <Box sx={{ paddingLeft: '6px', margin: '6px', textAlign: 'left', backgroundColor: '#ffffff' }}>
                                                <Grid container sx={{}}>
                                                    <Grid item xs={4} >
                                                        <Box sx={{}}>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '8px' }}>
                                                                INVOICE No
                                                            </Typography>
                                                            <Typography className={`${styles.text_Print_setup}`} sx={{ fontWeight: 'bold' }}>
                                                                Invoice Date
                                                            </Typography>
                                                            <Typography className={`${styles.text_Print_setup}`} sx={{ fontWeight: 'bold' }}>
                                                                Challan No
                                                            </Typography>
                                                            <Typography className={`${styles.text_Print_setup}`} sx={{ fontWeight: 'bold' }}>
                                                                Chalan Date
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={0.5}  >
                                                        <Box sx={{ textAlign: 'center' }}>
                                                            <Typography sx={{ fontSize: '8px' }}>:</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}>:</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}>:</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}>:</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7.5} sx={{}}>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '8px', fontWeight: 'bold' }}>INV/00-00/00001</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}>  DD / MM / YYYY</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}>  CH/00-00/00001</Typography>
                                                            <Typography className={`${styles.text_Print_setup}`}> DD / MM / YYYY</Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Box style={{ height: '8px' }}> </Box>
                                    <>
                                        <TableContainer sx={{ minHeight: topMargin === '190' ? 150 : topMargin === '225' ? 130 : 170, padding: '0px 1px 0px 1px' }}>
                                            <Table size="small" style={{ borderCollapse: 'collapse' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_head}`} style={{ borderLeft: 'none' }} width="354">Item Description</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_head}`}>HSN / SAC</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_head}`}>Qty</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_head}`} >Unit</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_head}`}>Rate</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_head}`}>GST <span style={{ fontSize: '6px' }}>(%) </span> </StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_head}`} style={{ borderRight: 'none' }}>Amount</StyledTableCellPrint>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* {JSON.parse(printData && printData.childRows).map((row) => ( */}
                                                    <StyledTableRow
                                                        sx={{ '&:last-child td, &:last-child th': { border: '1px solid #616161' } }} >
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ borderLeft: 'none' }} width="254">RUBBER / OIL / (201) </StyledTableCellPrint>
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} width="78">2004478</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} width="55">30</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} width="55">Liter</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} width="55">50</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} width="55">16</StyledTableCellPrint>
                                                        <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderRight: 'none' }}>1350.00</StyledTableCellPrint>
                                                    </StyledTableRow>
                                                    {/* ))} */}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                    <br />
                                    <>
                                        <Box style={{ height: '8px', borderTop: '1px solid #616161' }}> </Box>
                                        <Box sx={{ textAlign: 'left', borderTop: '1px solid #616161' }}>
                                            <Grid container >
                                                <Grid item xs={8} sx={{}}>
                                                    <Box sx={{ textAlign: 'left', }}>
                                                        <Typography sx={{ fontSize: '8px', padding: '4px 4px 4px 8px' }}>
                                                            Rupees one thousand seven hundred forty Only.
                                                        </Typography>
                                                        <Box sx={{ textAlign: 'left', borderTop: '1px solid #616161', padding: '4px 4px 4px 8px' }}>
                                                            <Typography sx={{ fontSize: '8px', fontWeight: 'bold' }}>
                                                                Terms & Conditions*
                                                            </Typography>
                                                            <Grid container spacing={0} sx={{ mt: 0 }}>
                                                                <Grid item xs={12}>
                                                                    <Box>
                                                                        <Typography style={{ paddingBottom: '2px', fontSize: '8px' }}>1. All sales are expressly subject to the Conditions </Typography>
                                                                        <Typography style={{ paddingBottom: '2px', fontSize: '8px' }}>2. Delivery terms shall be mutually agreed upon by the parties and shall be set</Typography>
                                                                        <Typography style={{ paddingBottom: '2px', fontSize: '8px' }}>3. Prices are as per the list price, unless agreed otherwise in exceptional cases.</Typography>
                                                                        <Typography style={{ paddingBottom: '2px', fontSize: '8px' }}>4. Taxes are subject to full recovery from the Buyer</Typography>
                                                                        <Typography style={{ paddingBottom: '2px', fontSize: '8px' }}>5. All payments must be made on terms agreed between Buyer and Seller.</Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={4} >
                                                    <Table aria-label="simple table" sx={{ borderCollapse: 'collapse', borderLeft: '1px solid #000000', height: '112px', }}>
                                                        <TableBody>
                                                            <TableRow>
                                                                <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ borderTop: 'none', fontWeight: 'bold' }}>Basic Amount </StyledTableCellPrint>
                                                                <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderTop: 'none', borderRight: 'none' }}>1500.00 </StyledTableCellPrint>
                                                            </TableRow>
                                                            <TableRow>
                                                                <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ fontWeight: 'bold' }}>CGST Amount</StyledTableCellPrint>
                                                                <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderRight: 'none' }}> 0.00 </StyledTableCellPrint>
                                                            </TableRow>
                                                            <TableRow>
                                                                <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ fontWeight: 'bold' }}>SGST Amount</StyledTableCellPrint>
                                                                <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderRight: 'none' }}> 0.00 </StyledTableCellPrint>
                                                            </TableRow>
                                                            <TableRow>
                                                                <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ fontWeight: 'bold' }}>IGST Amount</StyledTableCellPrint>
                                                                <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderRight: 'none' }}> 240.00 </StyledTableCellPrint>
                                                            </TableRow>
                                                            <TableRow>
                                                                <StyledTableCellPrint align="left" className={`${styles.print_setup_table_body}`} style={{ borderBottom: 'none', fontWeight: 'bold' }}>Total Amount</StyledTableCellPrint>
                                                                <StyledTableCellPrint align="right" className={`${styles.print_setup_table_body}`} style={{ borderRight: 'none', borderBottom: 'none' }}>1740.00 </StyledTableCellPrint>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </Grid>
                                            <Box sx={{ padding: '4px 4px 4px 4px', borderTop: '1px solid #000000' }}>
                                                <Typography sx={{ fontSize: '6px' }}>
                                                    I/we hereby certify that my/our Registration Certificate under the GST Act
                                                    2017 is in force on the date on which the sale of goods specified in this GST
                                                    invoice is made by me/ us & that the transaction of sale is covered by this
                                                    GST invoice has been affected me/us and it shall be accounted for in the
                                                    trunover of sales while filling of return & the due GST,if any, payable on the
                                                    sale has been paid or shall be paid.
                                                </Typography>
                                            </Box>
                                            <Grid container sx={{ borderTop: '1px solid #616161' }}>
                                                <Grid item xs={6} sx={{ borderRight: '1px solid#000000' }}>
                                                    <Box sx={{ padding: '2px 2px 2px 8px', }}>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '9px', }}>OUR BANK DETAILS</Typography>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}>A/C NAME- xyz </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}>A/C No- 00000000 </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}> BANK NAME- abc </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}>BRANCH- xyz </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '8px', }}>IFSC CODE- 00000000 </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Box sx={{ padding: '4px 14px 4px 4px', }}>
                                                        <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '8px' }}>
                                                            For <span style={{ fontSize: '10px', fontWeight: 'bold' }}> {userInfo.company}</span>
                                                        </Typography>
                                                        {signatureImgCheckbox == true ?
                                                            <Box sx={{ height: '42px', }}>
                                                                <img src={rows.length > 0 ? rows[0].signatureImage : signatureImage} style={{ width: '100%', height: '40px' }} />
                                                            </Box> :
                                                            <br />
                                                        }
                                                        <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '8px', fontSize: '8px' }}>
                                                            Authorized Signatory
                                                        </Typography>
                                                    </Box>

                                                </Grid>
                                                {footerImgCheckbox == true &&
                                                    <Box sx={{ height: '64px', width: '100%' }}>
                                                        <img src={rows.length > 0 ? rows[0].footerImage : footerImage} style={{ width: '100%', height: '60px' }} />
                                                    </Box>
                                                }
                                            </Grid>
                                        </Box>
                                    </>
                                </Paper>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage ? true : false}
                        autoHideDuration={2000}
                        onClose={handleCloseSuccessMsg}
                        message={successMessage}
                        action={actionMsg}
                    />
                }

            </Paper >

        </>
    )
}

export default PrintSetup